import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import moment from 'moment-jalaali'
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  makeStyles,
  CardHeader,
  Grid,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  // InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import { useSelector, useDispatch } from 'react-redux'
import {
  withStyles,
} from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { orange } from '@material-ui/core/colors'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { selectorCommon } from '../../../app/slices/commonSlice'
import { selectorLoading } from '../../../app/slices/loadingSlice'
import {
  updateProfile, getUserProfileInfo,
  addUserAddress,
  // getUserState,
  getUserAddresses,
  selectorUserAddress, deleteUserAddresses, editUserAddress,
  // getProfile,
} from '../../../app/slices/userSlice'
import { fixNumbers } from '../../../utils/getInitials'
import EditIcon from '../../../icons/EditIcon'
import DeleteIcon from '../../../icons/DeleteIcon'

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '50px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const CssDatePicker = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiPickersToolbar-toolbar': {
      backgroundColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '50px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(DatePicker)

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: 'orange',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

const OrangeRadio = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />)

const useStyles = makeStyles((theme) => ({
  root: {},
  item: {
    padding: theme.spacing(1.5),
    height: theme.spacing(13),
  },
  avatar: {
    marginBottom: theme.spacing(2),
    height: 100,
    width: 100,
  },
  datepicker: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  datePicker: {
    '& .MuiPickersToolbar-toolbar': {
      backgroundColor: 'orange !important',
    },
  },
  heading: {
    color: '#000',
    fontSize: '16px',
    fontWeight: 600,
    textAlign: 'right',
  },
  headingAddress: {
    color: '#000',
    fontSize: '16px',
    fontWeight: 600,
    marginLeft: '15px',
    marginTop: '20px',
  },
  addressWrap: {
    margin: '15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addressIconsWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'row',
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  accord: {
    boxShadow: 'none',
    '&::before': {
      backgroundColor: '#fff',
    },
  },
  addAddress: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'center',
  },
  addAddressIcon: {
    color: '#1b6edb',
    width: '60px',
    height: '60px',
  },
  addressDetails: {
    display: 'flex',
    flexFlow: 'row',
    '@media (max-width: 760)': {
      flexFlow: 'column',
    },
  },
  editDialog: {
    '& .MuiDialog-paperWidthSm': {
      width: '80%',
      height: '355px',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 20.6px 36px 20.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogContentRoot: {
    padding: '8px 11px',
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#a5a5a5, #b5b5b5)',
    color: '#000',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '15px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  editBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #f9b233',

    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#f9b233',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  accordSummeryRoot: {
    backgroundColor: '#efefef',
  },
}))

// const validationSchema = (t) => Yup.object().shape({
const validationSchema = () => Yup.object().shape({
  firstName: Yup.string()
    .max(255)
    .required('نام ضروری است'),
  lastName: Yup.string()
    .max(255)
    .required('نام خانوادگی ضروری است'),
  username: Yup.string()
    .max(255)
    .required('نام کاربری ضروری است'),
  birthDate: Yup.string()
    .required('تاریخ تولد ضروری است'),
  phoneNumber: Yup.string()
    .length(11, 'حتما باید 11 رقمی باشد')
    .required('شماره موبایل ضروری است'),
  // gender: Yup.string()
  //   .required('انتخاب جنسیت ضروری است'),
  country: Yup.string()
    .required('کشور ضروری است'),
  province: Yup.string()
    .required('استان ضروری است'),
  city: Yup.string()
    .required('شهر ضروری است'),
  email: Yup.string()
    .required('ایمیل ضروری است'),
  knowUs: Yup.number()
    .required('نحوه آشنایی ضروری است'),
  registerer: Yup.number()
    .required('ثبت نام کننده ضروری است'),
  mouseMonitorSkils: Yup.boolean()
    .required('توانمندی کار با موس و مانیتور یا صفحات لمسی ضروری است'),
  fatherName: Yup.string()
    .max(255)
    .required('نام پدر ضروری است'),
  // fatherBirthDate: Yup.object()
  //   .required(`${t('birthDate')} پدر ${t('required')}`)
  //   .typeError(`${t('birthDate')} ${t('required')}`),
  fatherJob: Yup.string()
    .required('شغل پدر ضروری است'),
  // fatherSalary: Yup.string()
  //   .min(7, 'مبلغ معتبر وارد کنید')
  //   .required('حقوق پدر ضروری است'),
  fatherEducation: Yup.string()
    .required('تحصیلات پدر ضروری است'),
  fatherTimeSpent: Yup.string()
    .required('میزان صرف وقت با پدر ضروری است'),
  homePhone: Yup.string()
    .min(8, 'حداقل باید 8 رقمی باشد')
    .max(13, 'حداکثر باید 13 رقمی باشد')
    .required(' شماره ثابت ضروری است'),
  // fatherHomePhone: Yup.string()
  //   .min(8, 'حداقل باید 8 رقمی باشد')
  //   .max(13, 'حداکثر باید 13 رقمی باشد')
  //   // .length(13, 'حتما باید 13 رقمی باشد')
  //   .required(' شماره ثابت پدر ضروری است'),
  fatherCellPhone: Yup.string()
    .length(11, 'حتما باید 11 رقمی باشد')
    .required('شماره موبایل پدر ضروری است'),
  motherName: Yup.string()
    .max(255)
    .required('نام مادر ضروری است'),
  // motherBirthDate: Yup.object()
  //   .required(`${t('birthDate')} مادر ${t('required')}`)
  //   .typeError(`${t('birthDate')} ${t('required')}`),
  motherJob: Yup.string()
    .required('شغل مادر ضروری است'),
  // motherSalary: Yup.string()
  //   .min(7, 'مبلغ معتبر وارد کنید')
  //   .required('حقوق مادر ضروری است'),
  motherEducation: Yup.string()
    .required('تحصیلات مادر ضروری است'),
  motherTimeSpent: Yup.string()
    .required('میزان صرف وقت با مادر ضروری است'),
  // motherHomePhone: Yup.string()
  //   .min(8, 'حداقل باید 8 رقمی باشد')
  //   .max(13, 'حداکثر باید 13 رقمی باشد')
  //   // .length(13, 'حتما باید 13 رقمی باشد')
  //   .required(' شماره ثابت مادر ضروری است'),
  motherCellPhone: Yup.string()
    .length(11, 'حتما باید 11 رقمی باشد')
    .required('شماره موبایل مادر ضروری است'),

  address: Yup.string(),
  addressPhoneNumber: Yup.string()
    .length(11, 'حتما باید 11 رقمی باشد'),
  postalCode: Yup.string()
    .length(10, 'حتما باید 10 رقمی باشد'),

  editedAddress: Yup.string(),
  editedPhoneNumber: Yup.string()
    .length(11, 'حتما باید 11 رقمی باشد'),
  editedPostalCode: Yup.string()
    .length(10, 'حتما باید 10 رقمی باشد'),

  // editedPostalCode: Yup.string(),
  // editedTitle: Yup.string(),
  // editedAddress: Yup.string(),
  // editedPhoneNumber: Yup.string().length(11, 'حتما باید 11 رقمی باشد'),
})

const ProfileInfo = ({
  className, canEdit, userinfo, fileRef, title, ...rest
}) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const genders = useSelector(selectorCommon)?.genders
  const countries = useSelector(selectorCommon)?.countries
  const regions = useSelector(selectorCommon)?.regions
  const knowUsTypes = useSelector(selectorCommon)?.knowUsTypes
  const registrerType = useSelector(selectorCommon)?.registrerType
  const educations = useSelector(selectorCommon)?.educations
  const timeSpents = useSelector(selectorCommon)?.timeSpents
  const loading = useSelector(selectorLoading)
  const userAddresses = useSelector(selectorUserAddress)
  const roleName = userinfo?.role?.name
  const dispatch = useDispatch()

  console.log('genders', genders)
  console.log('genders', userinfo?.gender)

  const [editAddress, setEditAddress] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [editErrorMsg, setEditErrorMsg] = useState('')
  const [userAddress, setUserAddress] = useState({})

  useEffect(() => {
    dispatch(getUserAddresses())
    dispatch(getUserProfileInfo())
  }, [])

  const formik = useFormik({
    initialValues: {
      firstName: userinfo?.firstName || '',
      lastName: userinfo?.lastName || '',
      username: userinfo?.userName || '',
      // gender: userinfo?.gender || genders[0].id,
      birthDate: userinfo?.birthDate ? moment(userinfo?.birthDate) : null,
      phoneNumber: userinfo?.phoneNumber
        ? `0${userinfo?.phoneNumber}` : '',
      country: userinfo?.country?.name || countries?.[0]?.name,
      province: userinfo?.province?.name || regions?.[0]?.name,
      city: userinfo?.city?.name || regions?.[0]?.cities?.[0]?.name,
      email: userinfo?.email || '',
      homePhone: userinfo?.homePhone || '',
      mouseMonitorSkils: Number(userinfo?.mouseMonitorSkils)
        ? Number(userinfo?.mouseMonitorSkils).toString() : '1',
      knowUs: userinfo?.knowUs || knowUsTypes[0].id,
      registerer: userinfo?.registerer || registrerType?.[0]?.id,
      /// father ///
      fatherName: userinfo?.father?.name || '',
      // fatherBirthDate: Number(userinfo?.father?.age)
      //   ? moment(moment().year() - Number(userinfo?.father?.age), 'YYYY')
      //   : moment(moment().year(), 'YYYY'),
      // fatherHomePhone: userinfo?.father?.homePhone || '',
      fatherCellPhone: userinfo?.father?.cellPhone || '',
      fatherJob: userinfo?.father?.job || '',
      // fatherSalary: userinfo?.father?.salary || '',
      fatherIsAlive: Number(userinfo?.father?.isAlive)
        ? Number(userinfo?.father?.isAlive).toString() : '1',
      fatherEducation: userinfo?.father?.education || educations?.[0]?.id,
      fatherTimeSpent: userinfo?.father?.timeSpent || timeSpents?.[0]?.id,
      /// mother ///
      motherName: userinfo?.mother?.name || '',
      // motherBirthDate: Number(userinfo?.mother?.age)
      //   ? moment(moment().year() - Number(userinfo?.mother?.age), 'YYYY')
      //   : moment(moment().year(), 'YYYY'),
      // motherHomePhone: userinfo?.mother?.homePhone || '',
      motherCellPhone: userinfo?.mother?.cellPhone || '',
      motherJob: userinfo?.mother?.job || '',
      // motherSalary: userinfo?.mother?.salary || '',
      motherIsAlive: Number(userinfo?.mother?.isAlive)
        ? Number(userinfo?.mother?.isAlive).toString() : '1',
      motherEducation: userinfo?.mother?.education || educations?.[0]?.id,
      motherTimeSpent: userinfo?.mother?.timeSpent || timeSpents?.[0]?.id,
      // address: userinfo?.address || '',
      // title: userinfo?.title || '',
      // postalCode: userinfo?.PostalCode || '',
      // addressPhoneNumber: userinfo?.PostalCode || '',
      // editedPhoneNumber: userinfo?.editedPhoneNumber || '',
      // editedAddress: userinfo?.editedAddress || '',
      // editedPostalCode: userinfo?.editedPostalCode || '',
      // editedTitle: userinfo?.editedTitle || '',
    },
    enableReinitialize: true,
    validationSchema: validationSchema(t),
    onSubmit: (fields) => {
      const user = {
        firstName: fields?.firstName ? fields?.firstName : null,
        lastName: fields?.lastName ? fields?.lastName : null,
        // gender: fields?.gender ? fields?.gender : null,
        country: fields?.country ? { name: fields?.country } : null,
        province: fields?.province
          ? { name: fields?.province } : null,
        city: fields?.city ? { name: fields?.city } : null,
        // address: fields?.address ? fields?.address : null,
        email: fields?.email ? fields?.email : null,
        homePhone: fields?.homePhone ? fields?.homePhone : null,
        mouseMonitorSkill: fields?.mouseMonitorSkils
          ? !!Number(fields?.mouseMonitorSkils) : null,
        knowUs: fields?.knowUs ? Number(fields?.knowUs) : null,
        father: {
          name: fields?.fatherName ? fields?.fatherName : null,
          // age: (fields?.fatherBirthDate.year() < moment().year())
          //   ? Number(moment().year()) - Number(fields?.fatherBirthDate?.year()) : 0,
          // homePhone: fields?.fatherHomePhone ? fields?.fatherHomePhone : null,
          cellPhone: fields?.fatherCellPhone ? fields?.fatherCellPhone : null,
          job: fields?.fatherJob ? fields?.fatherJob : null,
          // salary: fields?.fatherSalary ? Number(fields?.fatherSalary) : 0,
          isAlive: !!Number(fields?.fatherIsAlive),
          eduction: (fields?.fatherEducation || fields?.fatherEducation === 0)
            ? Number(fields?.fatherEducation) : null,
          timeSpent: fields?.fatherTimeSpent ? Number(fields?.fatherTimeSpent) : null,
        },
        mother: {
          name: fields?.motherName ? fields?.motherName : null,
          // age: (fields?.motherBirthDate.year() < moment().year())
          //   ? Number(moment().year()) - Number(fields?.motherBirthDate?.year()) : 0,
          // homePhone: fields?.motherHomePhone ? fields?.motherHomePhone : null,
          cellPhone: fields?.motherCellPhone ? fields?.motherCellPhone : null,
          job: fields?.motherJob ? fields?.motherJob : null,
          // salary: fields?.motherSalary ? Number(fields?.motherSalary) : 0,
          isAlive: fields?.motherIsAlive ? !!Number(fields?.motherIsAlive) : null,
          eduction: (fields?.motherEducation || fields?.motherEducation === 0)
            ? Number(fields?.motherEducation) : null,
          timeSpent: fields?.motherTimeSpent ? Number(fields?.motherTimeSpent) : null,
        },
        birthDate: fields?.birthDate
          ? fixNumbers(fields?.birthDate.format('YYYY-MM-DD')) : null,
        phoneNumber: fields?.phoneNumber ? fields?.phoneNumber?.substring(1) : null,
        registerer: fields?.registerer,
      }

      const formData = new FormData()
      const file = fileRef.current?.files?.[0]
      if (file) formData.append('photo', file)
      formData.append('user', JSON.stringify(user))

      dispatch(updateProfile(formData, () => {
        // dispatch(getUserProfileInfo())
        // dispatch(getUserState())
        // dispatch(getProfile())
      }))

      const address = {
        title: formik.values.title,
        address: formik.values.address,
        postalCode: formik.values.postalCode,
        phoneNumber: formik.values.addressPhoneNumber,
      }

      if (formik.values.title && formik.values.address
        && formik.values.postalCode && formik.values.addressPhoneNumber
        && !formik.errors.postalCode
        && !formik.errors.addressPhoneNumber
      ) {
        dispatch(addUserAddress(address))
        formik.values.title = ''
        formik.values.address = ''
        formik.values.postalCode = ''
        formik.values.addressPhoneNumber = ''
      }
    },

  })

  // const error = ''

  const addAddress = () => {
    const address = {
      title: formik.values.title,
      address: formik.values.address,
      postalCode: formik.values.postalCode,
      phoneNumber: formik.values.addressPhoneNumber,
    }

    if (formik.values.title && formik.values.address
      && formik.values.postalCode && formik.values.addressPhoneNumber
      && !formik.errors.postalCode
      && !formik.errors.addressPhoneNumber
    ) {
      dispatch(addUserAddress(address))
      formik.values.title = ''
      formik.values.address = ''
      formik.values.postalCode = ''
      formik.values.addressPhoneNumber = ''
      setErrorMsg('')
    } else {
      setErrorMsg('لطفا تمام فیلد ها را تکمیل کنید')
    }
  }

  const deleteAddress = (id) => {
    dispatch(deleteUserAddresses(id))
  }

  const handleClose = () => {
    setEditAddress(false)
  }

  const openEditAddress = (id) => {
    const address = userAddresses?.data?.find((item) => item?.id === id)

    console.log(address)

    setUserAddress(address)
    setEditAddress(true)
  }

  const addEditedAddres = () => {
    // const editedPostCode = document.getElementById('editPostalCode')

    // if (userAddress) {
    //   setEditAddress(false)

    const newAddress = {
      id: userAddress?.id,
      title: userAddress?.title,
      address: userAddress?.address,
      postalCode: userAddress?.postalCode,
      phoneNumber: userAddress?.phoneNumber,
    }
    // if (userAddress?.title && userAddress?.address
    //    && userAddress?.postalCode && userAddress?.addressPhoneNumber) {

    if (
      userAddress?.postalCode?.length >= 10
        && userAddress?.phoneNumber?.length >= 11
        && userAddress?.title?.length
        && userAddress?.address?.length
    ) {
      dispatch(editUserAddress(newAddress))
      setEditErrorMsg('')
      setEditAddress(false)
    } else {
      setEditErrorMsg('لطفا تمام فیلد ها را تکمیل کنید')
      setEditAddress(true)
    }

    // if (userAddress?.postalCode?.length < 10) {
    //   setErrorMsg('لطفا تمام فیلد ها را تکمیل کنید')
    // }
    // alert(editedPostCode?.validity?.valid)
    // }
  }

  return (
    <form
      className={clsx(classes.root, className)}
      {...rest}
      onSubmit={formik.handleSubmit}
      // encType="multipart/form-data"
    >
      <Card style={{ borderRadius: '20px' }}>
        <CardHeader
          title={title}
        />
        <Divider />
        <CardContent>
          <Grid
            container
          >
            <Grid
              item
              xs={12}
            >
              <Typography
                color="textPrimary"
                variant="h4"
              >
                {roleName}
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
              CssTextField
            >

              <CssTextField
                error={Boolean(formik.touched.firstName && formik.errors.firstName)}
                fullWidth
                helperText={formik.touched.firstName && formik.errors.firstName}
                label="نام*"
                margin="normal"
                name="firstName"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.firstName}
                variant="outlined"
                autoFocus
                disabled={!canEdit}
              />

            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.lastName && formik.errors.lastName)}
                fullWidth
                helperText={formik.touched.lastName && formik.errors.lastName}
                label="نام خانوادگی*"
                margin="normal"
                name="lastName"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.lastName}
                variant="outlined"
                disabled={!canEdit}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.username && formik.errors.username)}
                fullWidth
                helperText={formik.touched.username && formik.errors.username}
                label="نام کاربری(کد ملی)*"
                margin="normal"
                name="username"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.username}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssDatePicker
                name="birthDate"
                classes={{ root: classes.datepicker }}
                inputVariant="outlined"
                label="تاریخ تولد*"
                fullWidth
                clearable
                okLabel="تأیید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                value={formik.values.birthDate}
                // disabled
                onChange={(e) => {
                  formik.setFieldValue('birthDate', e)
                }}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.phoneNumber && formik.errors.phoneNumber)}
                fullWidth
                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                label="شماره موبایل*"
                margin="normal"
                name="phoneNumber"
                onBlur={formik.handleBlur}
                onChange={(e) => (e.target.validity.valid ? formik.handleChange(e) : undefined)}
                type="text"
                value={formik.values.phoneNumber}
                variant="outlined"
                disabled
                inputProps={{
                  maxLength: 11,
                  pattern: '[0-9]*',
                }}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.homePhone
                              && formik.errors.homePhone)}
                fullWidth
                helperText={formik.touched.homePhone
                              && formik.errors.homePhone}
                // label="شماره ثابت*"
                label="شماره ثابت همراه با کد شهر *"
                margin="normal"
                name="homePhone"
                onBlur={formik.handleBlur}
                onChange={(e) => (e.target.validity.valid
                  ? formik.handleChange(e) : undefined)}
                type="text"
                value={formik.values.homePhone}
                variant="outlined"
                inputProps={{
                  maxLength: 13,
                  pattern: '[0-9]*',
                }}
                disabled={!canEdit}
              />
            </Grid>
            {/* <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.gender && formik.errors.gender)}
                select
                fullWidth
                helperText={formik.touched.gender && formik.errors.gender}
                label="جنسیت*"
                margin="normal"
                name="gender"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.gender}
                variant="outlined"
                disabled={!canEdit}
              >
                {genders.map((gender) => (
                  <StyledMenuItem key={gender.id} value={gender.id}>
                    {t(gender.name)}
                  </StyledMenuItem>
                ))}
              </CssTextField>
            </Grid> */}
            <Grid
              item
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.email && formik.errors.email)}
                fullWidth
                helperText={formik.touched.email && formik.errors.email}
                label="ایمیل*"
                margin="normal"
                name="email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.email}
                variant="outlined"
                disabled={!canEdit}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.country && formik.errors.country)}
                select
                fullWidth
                helperText={formik.touched.country && formik.errors.country}
                label="کشور*"
                margin="normal"
                name="country"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.country}
                variant="outlined"
                disabled={!canEdit}
              >
                {countries.map((country) => (
                  <StyledMenuItem key={country.id} value={country?.name}>
                    {t(country.name)}
                  </StyledMenuItem>
                ))}
              </CssTextField>
            </Grid>

            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.province && formik.errors.province)}
                select
                fullWidth
                helperText={formik.touched.province && formik.errors.province}
                label="استان*"
                margin="normal"
                name="province"
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e)
                  const cities = regions?.find((region) => region.name === e.target.value)?.cities
                  formik.setFieldValue('city', cities?.[0]?.name)
                }}
                type="text"
                value={formik.values.province}
                variant="outlined"
                disabled={!canEdit}
              >
                {regions?.map((region) => (
                  <StyledMenuItem key={region.id} value={region?.name}>
                    {region.name}
                  </StyledMenuItem>
                ))}
              </CssTextField>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.city && formik.errors.city)}
                select
                fullWidth
                helperText={formik.touched.city && formik.errors.city}
                label="شهر*"
                margin="normal"
                name="city"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.city}
                variant="outlined"
                disabled={!canEdit}
              >
                {regions.find((region) => region.name === formik.values.province)
                  ?.cities?.map((city) => (
                    <StyledMenuItem key={city.id} value={city?.name}>
                      {city.name}
                    </StyledMenuItem>
                  ))}
              </CssTextField>
            </Grid>

            {/* <Grid
              item
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.email && formik.errors.email)}
                fullWidth
                helperText={formik.touched.email && formik.errors.email}
                label="ایمیل"
                margin="normal"
                name="email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.email}
                variant="outlined"
                disabled={!canEdit}
              />
            </Grid> */}

            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.knowUs && formik.errors.knowUs)}
                select
                fullWidth
                helperText={formik.touched.knowUs && formik.errors.knowUs}
                label="نحوه آشنایی با ما*"
                margin="normal"
                name="knowUs"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.knowUs}
                variant="outlined"
                disabled={!canEdit}
              >
                {knowUsTypes.map((knowUs) => (
                  <StyledMenuItem key={knowUs.id} value={knowUs.id}>
                    {t(knowUs.name)}
                  </StyledMenuItem>
                ))}
              </CssTextField>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.registerer && formik.errors.registerer)}
                select
                fullWidth
                helperText={formik.touched.registerer && formik.errors.registerer}
                label="ثبت نام کننده*"
                margin="normal"
                name="registerer"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.registerer}
                variant="outlined"
                disabled
              >
                {registrerType.map((registerer) => (
                  <StyledMenuItem key={registerer.id} value={registerer.id}>
                    {t(registerer.name)}
                  </StyledMenuItem>
                ))}
              </CssTextField>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                margin="normal"
                disabled={!canEdit}
              >
                <FormLabel component="legend">
                  توانایی کار با موس و مانیتور را دارید؟*
                </FormLabel>
                <RadioGroup
                  aria-label="mouseMonitorSkils"
                  name="mouseMonitorSkils"
                  value={formik.values.mouseMonitorSkils}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="mouseMonitorSkils"
                    value="0"
                    control={(<OrangeRadio />)}
                    label="خیر"
                  />
                  <FormControlLabel
                    name="mouseMonitorSkils"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="بله"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          {/* {[1, 2, 3].includes(formik.values.registerer) && ( */}
          <Accordion defaultExpanded classes={{ root: classes.accord }}>
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
                // classes={{ root: classes.accordTitle }}
              classes={{ content: classes.accordContent, root: classes.accordSummeryRoot }}
                  // expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                اطلاعات والدین
              </Typography>
            </AccordionSummary>
            {/* <Divider /> */}

            <Grid xs={12}>

              <AccordionDetails>
                <>
                  <Grid container>
                    {/* {
                    [1, 2].includes(formik.values.registerer) && ( */}
                    <>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.fatherName && formik.errors.fatherName)}
                          fullWidth
                          helperText={formik.touched.fatherName && formik.errors.fatherName}
                          label="نام پدر*"
                          margin="normal"
                          name="fatherName"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.fatherName}
                          variant="outlined"
                          disabled={!canEdit}
                        />
                      </Grid>
                      {/* <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssDatePicker
                          name="fatherBirthDate"
                          classes={{ root: classes.datepicker }}
                          autoOk
                          views={['year']}
                          inputVariant="outlined"
                          label="سال تولد*"
                          fullWidth
                          clearable
                          okLabel="تأیید"
                          cancelLabel="لغو"
                          clearLabel="پاک کردن"
                          labelFunc={(date) => (date ? date.format('jYYYY') : '')}
                          value={formik.values.fatherBirthDate}
                          onChange={(e) => {
                            formik.setFieldValue('fatherBirthDate', e)
                          }}
                          DialogProps={{ className: classes.datePicker }}
                          disabled={!canEdit}
                        />
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.fatherHomePhone
                              && formik.errors.fatherHomePhone)}
                          fullWidth
                          helperText={formik.touched.fatherHomePhone
                              && formik.errors.fatherHomePhone}
                          label="شماره ثابت پدر*"
                          margin="normal"
                          placeholder="22441188 021"
                          name="fatherHomePhone"
                          onBlur={formik.handleBlur}
                          onChange={(e) => (e.target.validity.valid
                            ? formik.handleChange(e) : undefined)}
                          type="text"
                          value={formik.values.fatherHomePhone}
                          variant="outlined"
                          inputProps={{
                            maxLength: 13,
                            pattern: '[0-9]*',
                          }}
                          disabled={!canEdit}
                        />
                      </Grid> */}
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.fatherCellPhone
                              && formik.errors.fatherCellPhone)}
                          fullWidth
                          helperText={formik.touched.fatherCellPhone
                              && formik.errors.fatherCellPhone}
                          label="شماره موبایل پدر*"
                          margin="normal"
                          name="fatherCellPhone"
                          onBlur={formik.handleBlur}
                          onChange={(e) => (e.target.validity.valid
                            ? formik.handleChange(e) : undefined)}
                          type="text"
                          value={formik.values.fatherCellPhone}
                          variant="outlined"
                          inputProps={{
                            maxLength: 11,
                            pattern: '[0-9]*',
                          }}
                          disabled={!canEdit}
                        />
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.fatherJob && formik.errors.fatherJob)}
                          fullWidth
                          helperText={formik.touched.fatherJob && formik.errors.fatherJob}
                          label="شغل*"
                          margin="normal"
                          name="fatherJob"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.fatherJob}
                          variant="outlined"
                          disabled={!canEdit}
                        />
                      </Grid>
                      {/* <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.fatherSalary
                              && formik.errors.fatherSalary)}
                          fullWidth
                          helperText={formik.touched.fatherSalary && formik.errors.fatherSalary}
                          label="حقوق ماهیانه پدر*"
                          margin="normal"
                          name="fatherSalary"
                          onBlur={formik.handleBlur}
                          onChange={(e) => ((Number(e.target.value) || !e.target.value)
                            ? formik.handleChange(e) : undefined)}
                          type="text"
                          value={formik.values.fatherSalary}
                          variant="outlined"
                          InputProps={{
                            endAdornment: <InputAdornment position="start">تومان</InputAdornment>,
                          }}
                          disabled={!canEdit}
                        />
                      </Grid> */}
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.fatherEducation
                              && formik.errors.fatherEducation)}
                          select
                          fullWidth
                          helperText={formik.touched.fatherEducation
                              && formik.errors.fatherEducation}
                          label="میزان تحصیلات پدر*"
                          margin="normal"
                          name="fatherEducation"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.fatherEducation}
                          variant="outlined"
                          disabled={!canEdit}
                        >
                          {educations.map((education) => (
                            <StyledMenuItem key={education.id} value={education.id}>
                              {t(education.name)}
                            </StyledMenuItem>
                          ))}
                        </CssTextField>
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.fatherTimeSpent
                              && formik.errors.fatherTimeSpent)}
                          select
                          fullWidth
                          helperText={formik.touched.fatherTimeSpent
                              && formik.errors.fatherTimeSpent}
                          label="میزان صرف وقت پدر با فرزند*"
                          margin="normal"
                          name="fatherTimeSpent"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.fatherTimeSpent}
                          variant="outlined"
                          disabled={!canEdit}
                        >
                          {timeSpents.map((timeSpent) => (
                            <StyledMenuItem key={timeSpent.id} value={timeSpent.id}>
                              {timeSpent.name}
                            </StyledMenuItem>
                          ))}
                        </CssTextField>
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <FormControl
                          component="fieldset"
                          fullWidth
                          style={{ flexDirection: 'row' }}
                          margin="normal"
                          disabled={!canEdit}
                        >
                          <FormLabel
                            component="legend"
                          >
                            پدر در قید حیات است؟*
                          </FormLabel>
                          <RadioGroup
                            name="fatherIsAlive"
                            value={formik.values.fatherIsAlive}
                            onChange={formik.handleChange}
                            style={{ flexDirection: 'row' }}
                          >
                            <FormControlLabel
                              name="fatherIsAlive"
                              value="0"
                              control={(<OrangeRadio />)}
                              label="خیر"
                            />
                            <FormControlLabel
                              name="fatherIsAlive"
                              value="1"
                              control={(<OrangeRadio />)}
                              label="بله"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </>
                    {/* )
                  } */}
                    {/* {
                    [1, 3].includes(formik.values.registerer) && ( */}
                    <>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.motherName && formik.errors.motherName)}
                          fullWidth
                          helperText={formik.touched.motherName && formik.errors.motherName}
                          label="نام مادر*"
                          margin="normal"
                          name="motherName"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.motherName}
                          variant="outlined"
                          disabled={!canEdit}
                        />
                      </Grid>
                      {/* <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssDatePicker
                          name="motherBirthDate"
                          classes={{ root: classes.datepicker }}
                          autoOk
                          views={['year']}
                          inputVariant="outlined"
                          label="سال تولد*"
                          fullWidth
                          clearable
                          okLabel="تأیید"
                          cancelLabel="لغو"
                          clearLabel="پاک کردن"
                          labelFunc={(date) => (date ? date.format('jYYYY') : '')}
                          value={formik.values.motherBirthDate}
                          onChange={(e) => {
                            formik.setFieldValue('motherBirthDate', e)
                          }}
                          DialogProps={{ className: classes.datePicker }}
                          disabled={!canEdit}
                        />
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.motherHomePhone
                              && formik.errors.motherHomePhone)}
                          fullWidth
                          helperText={formik.touched.motherHomePhone
                              && formik.errors.motherHomePhone}
                          label="شماره ثابت مادر*"
                          placeholder="22441188 021"
                          margin="normal"
                          name="motherHomePhone"
                          onBlur={formik.handleBlur}
                          onChange={(e) => (e.target.validity.valid
                            ? formik.handleChange(e) : undefined)}
                          type="text"
                          value={formik.values.motherHomePhone}
                          variant="outlined"
                          inputProps={{
                            maxLength: 13,
                            pattern: '[0-9]*',
                          }}
                          disabled={!canEdit}
                        />
                      </Grid> */}
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.motherCellPhone
                              && formik.errors.motherCellPhone)}
                          fullWidth
                          helperText={formik.touched.motherCellPhone
                              && formik.errors.motherCellPhone}
                          label="شماره موبایل مادر*"
                          margin="normal"
                          name="motherCellPhone"
                          onBlur={formik.handleBlur}
                          onChange={(e) => (e.target.validity.valid
                            ? formik.handleChange(e) : undefined)}
                          type="text"
                          value={formik.values.motherCellPhone}
                          variant="outlined"
                          inputProps={{
                            maxLength: 11,
                            pattern: '[0-9]*',
                          }}
                          disabled={!canEdit}
                        />
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.motherJob && formik.errors.motherJob)}
                          fullWidth
                          helperText={formik.touched.motherJob && formik.errors.motherJob}
                          label="شغل مادر*"
                          margin="normal"
                          name="motherJob"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.motherJob}
                          variant="outlined"
                          disabled={!canEdit}
                        />
                      </Grid>
                      {/* <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.motherSalary
                              && formik.errors.motherSalary)}
                          fullWidth
                          helperText={formik.touched.motherSalary && formik.errors.motherSalary}
                          label="حقوق ماهیانه مادر*"
                          margin="normal"
                          name="motherSalary"
                          onBlur={formik.handleBlur}
                          onChange={(e) => ((Number(e.target.value) || !e.target.value)
                            ? formik.handleChange(e) : undefined)}
                          type="text"
                          value={formik.values.motherSalary}
                          variant="outlined"
                          InputProps={{
                            endAdornment: <InputAdornment position="start">تومان</InputAdornment>,
                          }}
                          disabled={!canEdit}
                        />
                      </Grid> */}
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.motherEducation
                        && formik.errors.motherEducation)}
                          select
                          fullWidth
                          helperText={formik.touched.motherEducation
                              && formik.errors.motherEducation}
                          label="میزان تحصیلات مادر*"
                          margin="normal"
                          name="motherEducation"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.motherEducation}
                          variant="outlined"
                          disabled={!canEdit}
                        >
                          {educations.map((education) => (
                            <StyledMenuItem key={education.id} value={education.id}>
                              {t(education.name)}
                            </StyledMenuItem>
                          ))}
                        </CssTextField>
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <CssTextField
                          error={Boolean(formik.touched.motherTimeSpent
                        && formik.errors.motherTimeSpent)}
                          select
                          fullWidth
                          helperText={formik.touched.motherTimeSpent
                              && formik.errors.motherTimeSpent}
                          label="میزان صرف وقت مادر با فرزند*"
                          margin="normal"
                          name="motherTimeSpent"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.motherTimeSpent}
                          variant="outlined"
                          disabled={!canEdit}
                        >
                          {timeSpents.map((timeSpent) => (
                            <StyledMenuItem key={timeSpent.id} value={timeSpent.id}>
                              {timeSpent.name}
                            </StyledMenuItem>
                          ))}
                        </CssTextField>
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                        classes={{ root: classes.item }}
                      >
                        <FormControl
                          component="fieldset"
                          fullWidth
                          style={{ flexDirection: 'row' }}
                          margin="normal"
                          disabled={!canEdit}
                        >
                          <FormLabel
                            component="legend"
                          >
                            مادر در قید حیات است؟*
                          </FormLabel>
                          <RadioGroup
                            name="motherIsAlive"
                            value={formik.values.motherIsAlive}
                            onChange={formik.handleChange}
                            style={{ flexDirection: 'row' }}
                          >
                            <FormControlLabel
                              name="motherIsAlive"
                              value="0"
                              control={(<OrangeRadio />)}
                              label="خیر"
                            />
                            <FormControlLabel
                              name="motherIsAlive"
                              value="1"
                              control={(<OrangeRadio />)}
                              label="بله"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </>
                    {/* )
                  } */}
                  </Grid>
                </>
              </AccordionDetails>
              <Divider />

            </Grid>
          </Accordion>

          {/* )} */}
          <Divider />

          <Typography className={classes.headingAddress}>
            مدیریت آدرس
          </Typography>
          {userAddresses?.data?.map((item) => (
            <>
              <div
                key={item?.id}
                className={classes.addressWrap}
              >
                <p>{item?.address}</p>
                <div
                  className={classes.addressIconsWrap}
                >
                  <IconButton onClick={() => openEditAddress(item?.id)}>
                    <EditIcon className={classes.icons} />
                  </IconButton>
                  <IconButton onClick={() => deleteAddress(item?.id)}>
                    <DeleteIcon className={classes.icons} />
                  </IconButton>
                </div>

              </div>
              <Divider />
            </>
          ))}
          <Grid
            item
            xs={12}
            container
          >
            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.title && formik.errors.title)}
                fullWidth
                helperText={formik.touched.title && formik.errors.title}
                label="عنوان*"
                margin="normal"
                name="title"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.title}
                variant="outlined"
              />
            </Grid>

            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.postalCode && formik.errors.postalCode)}
                fullWidth
                helperText={formik.touched.postalCode && formik.errors.postalCode}
                label="کد پستی*"
                margin="normal"
                name="postalCode"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.postalCode}
                variant="outlined"
                inputProps={{
                  maxLength: 10,
                  pattern: '[0-9]*',
                }}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              classes={{ root: classes.item }}
            >
              <CssTextField
                error={Boolean(formik.touched.addressPhoneNumber
                && formik.errors.addressPhoneNumber)}
                helperText={formik.touched.addressPhoneNumber && formik.errors.addressPhoneNumber}
                fullWidth
                label="شماره موبایل*"
                margin="normal"
                name="addressPhoneNumber"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="text"
                value={formik.values.addressPhoneNumber}
                variant="outlined"
                inputProps={{
                  maxLength: 11,
                  pattern: '[0-9]*',
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            classes={{ root: classes.item }}
            className={classes.addAddress}
          >
            <CssTextField
              error={Boolean(formik.touched.address && formik.errors.address)}
              fullWidth
              helperText={formik.touched.address && formik.errors.address}
              label="آدرس*"
              margin="normal"
              name="address"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="text"
              value={formik.values.address}
              variant="outlined"
              disabled={!canEdit}
              multiline
              rows={2}
              maxRows={8}
            />
            <IconButton onClick={addAddress}>
              <AddCircleIcon
                classes={{ root: classes.addAddressIcon }}
              />
            </IconButton>
          </Grid>
          <p style={{ color: '#ff3434' }}>{errorMsg}</p>

          <Dialog
            className={classes.editDialog}
            open={editAddress}
            onClose={() => handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">ویرایش آدرس</DialogTitle>
            <DialogContent
              classes={{ root: classes.dialogContentRoot }}
            >
              <Grid
                item
                xs={12}
                container
              >
                <Grid
                  item
                  md={4}
                  xs={12}
                  classes={{ root: classes.item }}
                >
                  <CssTextField
                    error={Boolean(formik.touched.editedTitle && formik.errors.editedTitle)}
                    fullWidth
                    helperText={formik.touched.editedTitle && formik.errors.editedTitle}
                    label="عنوان*"
                    margin="normal"
                    name="editedTitle"
                    onChange={(e) => setUserAddress({ ...userAddress, title: e.target.value })}
                    type="text"
                    value={userAddress?.title}
                    variant="outlined"
                  />
                </Grid>

                <Grid
                  item
                  md={4}
                  xs={12}
                  classes={{ root: classes.item }}
                >
                  <CssTextField
                    error={Boolean(formik.touched.editedPostalCode
                            && formik.errors.editedPostalCode)}
                    fullWidth
                    helperText={formik.touched.editedPostalCode && formik.errors.editedPostalCode}
                    label="کد پستی*"
                    id="editPostalCode"
                    margin="normal"
                    name="editedPostalCode"
                    onChange={(e) => setUserAddress({
                      ...userAddress,
                      postalCode: e.target.value,
                    })}
                    type="text"
                    value={userAddress?.postalCode}
                    variant="outlined"
                    inputProps={{
                      maxLength: 10,
                      pattern: '[0-9]*',
                    }}
                  />
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  classes={{ root: classes.item }}
                >
                  <CssTextField
                    error={Boolean(formik.touched.editedPhoneNumber
                    && formik.errors.editedPhoneNumber)}
                    fullWidth
                    helperText={formik.touched.editedPhoneNumber && formik.errors.editedPhoneNumber}
                    label="شماره موبایل*"
                    margin="normal"
                    name="editedPhoneNumber"
                    onChange={(e) => setUserAddress({
                      ...userAddress,
                      phoneNumber: e.target.value,
                    })}
                    type="text"
                    value={userAddress?.phoneNumber}
                    variant="outlined"
                    inputProps={{
                      maxLength: 11,
                      pattern: '[0-9]*',
                    }}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                classes={{ root: classes.item }}
                className={classes.addAddress}
              >
                <CssTextField
                  error={Boolean(formik.touched.editAddress && formik.errors.editAddress)}
                  fullWidth
                  helperText={formik.touched.editAddress && formik.errors.editAddress}
                  label="آدرس*"
                  margin="normal"
                  name="editedAddress"
                  onChange={(e) => setUserAddress({ ...userAddress, address: e.target.value })}
                  type="text"
                  value={userAddress?.address}
                  variant="outlined"
                  multiline
                  rows={2}
                  maxRows={10}
                />
              </Grid>
              <span style={{ color: '#ff3434' }}>{editErrorMsg}</span>
            </DialogContent>
            <DialogActions className={classes.dialogButtons}>
              <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
                لغو
              </Button>
              <Button
                onClick={() => addEditedAddres()}
                className={classes.editBtn}
                autoFocus
              >
                ویرایش
              </Button>
            </DialogActions>
          </Dialog>
        </CardContent>
        {
          canEdit && (
            <>
              <Divider />
              <Box
                display="flex"
                justifyContent="flex-end"
                p={2}
              >
                <Button
                  color="primary"
                  disabled={!!loading}
                  size="large"
                  type="submit"
                  variant="contained"
                  fullWidth
                >
                  ذخیره
                </Button>
              </Box>

            </>
          )
        }
      </Card>
    </form>
  )
}

ProfileInfo.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  className: PropTypes.string,
  userinfo: PropTypes.object,
  fileRef: PropTypes.object,
  title: PropTypes.string,
}

export default ProfileInfo
